import type ProjectReport from "../../../models/domain/project_report";
import type { AvvirEvent } from "type_aliases";

export type ProjectReportAddedEvent = AvvirEvent<typeof PROJECT_REPORT_ADDED, {projectId: string, report: ProjectReport}>

const projectReportAdded = (projectId: string, projectReport : ProjectReport): ProjectReportAddedEvent => ({
  type: PROJECT_REPORT_ADDED,
  payload: {
    projectId,
    report: projectReport
  }
});

export const PROJECT_REPORT_ADDED = "project_report_added";

export default projectReportAdded;
